
let validatePasswordStrength = {

    charLength: function(password) {
        if( password.length >= 6 ) {
            return true;
        }
    },

    lowercase: function(password) {
        let regex = /(?=.*[a-z])/;

        if( regex.test(password) ) {
            return true;
        }
    },

    uppercase: function(password) {
        let regex = /(?=.*[A-Z])/;

        if( regex.test(password) ) {
            return true;
        }
    },

    special: function(password) {
        let regex = /(?=.*[\W])/;

        if( regex.test(password) ) {
            return true;
        }
    },

    hasNumber: function (password) {
        let regex = /(?=.*\d)/;

        if( regex.test(password)){
            return true;
        }
    }
};

export default validatePasswordStrength;


// WEBPACK FOOTER //
// ./src/utils/password_validation.js